import React, { useContext } from 'react';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import Footer from '../Main/components/Footer';
import useMediaQuery from '../../utils/hooks/mediaQuery.hook';
import PaymentResult from './components/PaymentResult';
import PaymentResultSkeleton from './components/skeletons/PaymentResultSkeleton';
import OrderNotFound from './components/OrderNotFound';
import { CampaignContext } from '../../context/CampaignWrapper';
import useDemoOrder from '../../utils/hooks/demoOrder';
import { useOrderQuery } from '../../generated/graphql';

const PaymentResultContainer = () => {
  const { loading: campaignLoading } = useContext(CampaignContext);
  const { order: demoOrder } = useDemoOrder() || {};
  const { isMobile } = useMediaQuery();
  const { orderId } = useParams();
  const newOrderId = ((orderId || '').match(/[a-f\d]{24}/i) || [])[0];
  const { slug } = useParams();

  const { data, loading: orderLoading } = useOrderQuery({
    skip: !newOrderId,
    variables: { _id: newOrderId || '' },
  });

  const order = slug === 'demo'
    ? demoOrder
    : data?.orderById;

  if (orderLoading || campaignLoading) return <PaymentResultSkeleton />;

  if (!order) return <OrderNotFound />;

  return (
    <>
      <Container className="payment-result-container">
        <PaymentResult order={order} />
      </Container>
      {!isMobile && (
        <Footer />
      )}
    </>
  );
};

export default PaymentResultContainer;
